import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PosUploadModal } from "./PosUploadModal";
import { MenuList } from "./MenuList";
import { MenuAllergens } from "./MenuAllergens";
import { MenuUpdateModal } from "./MenuUpdateModal";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import Button from "../../components/Button/Button";
import Loading from "../../components/Loading";
import { PuffLoader } from "react-spinners";
import { useGetMenuList, useImportFromPost } from '../../network';
import { useSetFilters } from "../../hooks/useSetFilters";
import {FormField} from "../../components/FormField";
import { CustomSelect } from '../../components/Shared/CustomSelect';

export const MenuPage = () => {
    const setFilters = useSetFilters();
    const searchParams = new URLSearchParams(location.search);
    const statusParams = searchParams.get("status") || "active";

    const { data, isLoading, isFetching } = useGetMenuList({
        status: statusParams,
    });
    const { mutate: importFromPos } = useImportFromPost()

    const menuList = data?.data?.data || [];
    const [alert, setAlert] = useState(false);
    const [openCreateMenu, setOpenCreateMenu] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openUpdaetMenuModal, setOpenUpdateMenuModal] = useState(false);
    const [openAllergensModal, setOpenAllergensModal] = useState(false);
    const [POSUploadedData, setPOSUploadedData] = useState(false);
    const [isConnectedPOS, setIsConnectedPOS] = useState(true);
    const [viewMenu, setViewMenu] = useState({
        isOpen: false,
        id: null,
    });
    const { t } = useTranslation();

    const onGoToMenuView = (id) => {
        setViewMenu({ isOpen: true, id });
    };

    const createMenuHandle = () => {
        setOpenCreateMenu((prev) => !prev);
    };

    const onCloseModal = () => {
        setOpenModal((prev) => !prev);
    };
    const onOpenModal = () => {
        setOpenModal((prev) => !prev);
        // dispatch(onIsConnectedPOS(restId))
    };

    const onUpdateMenuOpenModal = () => {
        setOpenUpdateMenuModal((prev) => !prev);
    };
    const onUpdateMenuCloseModal = () => {
        setOpenUpdateMenuModal((prev) => !prev);
    };
    const onUpdateMenu = () => {
        setAlert(true);

        importFromPos();
        onUpdateMenuCloseModal();
    };

    const onImportHandler = () => {
        setAlert(true)
        importFromPos();
        setPOSUploadedData((prev) => !prev);
        onCloseModal();
    };

    const POSConectionHandler = () => {
        // dispatch(onPOSConnection(restId))
    };

    const allergensModalOpenHandler = () => {
        setOpenAllergensModal((prev) => !prev);
    };
    const allergensModalCloseHandler = () => {
        setOpenAllergensModal((prev) => !prev);
    };

    const onSaveAllergens = () => {
        allergensModalCloseHandler();
    };

    const handleChangeStatus = (status) => {
        setFilters({ status: status.value });
    };

    const filterOptions = [
        { value: "active", label: t("menu_status.active") },
        { value: "archived", label: t("menu_status.archived") },
    ];

    const pages = [{ name: t("Menu"), path: "/chain/menu" }];

    const activeStatus = filterOptions.find(status => status.value === statusParams)
    return (
        <div className="max-w-screen-lg px-4 sm:px-8 lg:px-10 xl:px-12">
            <Breadcrumbs pages={pages} />
            <div className="max-w-5xl mb-6 flex justify-between">
                <div className="flex items-center gap-3">
                    <Button
                        isUpperCase={false}
                        type="link"
                        to="/chain/menu/create"
                        className="h-9 py-2 inline-flex items-center rounded-lg border border-transparent bg-purple-500 text-sm text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                        fontWeight="font-normal"
                        tracing="tracking-normal"
                    >
                        {t("Create Menu")}
                    </Button>
                    {POSUploadedData ? (
                        <Button
                            isUpperCase={false}
                            fontWeight="font-normal"
                            tracing="tracking-normal"
                            type="button"
                            className="h-9 inline-flex justify-center px-4 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-gray-900 hover:bg-gray-700 active:bg-gray-800 focus:outline-none"
                            onClick={onUpdateMenuOpenModal}
                        >
                            {t("Update menu from POS")}
                        </Button>
                    ) : (
                        <Button
                            isUpperCase={false}
                            fontWeight="font-normal"
                            tracing="tracking-normal"
                            type="button"
                            className="h-9"
                            onClick={onOpenModal}
                        >
                            {t("Import from POS")}
                        </Button>
                    )}
                    {!isLoading && isFetching && (
                        <div className="ml-4 mb-1">
                            <PuffLoader color="#7A5AF8" size={36} />
                        </div>
                    )}
                </div>
                <MenuUpdateModal
                    visible={openUpdaetMenuModal}
                    onClose={onUpdateMenuCloseModal}
                    onUpdate={onUpdateMenu}
                />

                <PosUploadModal
                    visible={openModal}
                    onClose={onCloseModal}
                    isConnectedPOS={isConnectedPOS}
                    onImport={onImportHandler}
                    POSConection={POSConectionHandler}
                />
                <FormField>
                    <CustomSelect
                        className="text-left w-40"
                        onChange={handleChangeStatus}
                        options={filterOptions}
                        value={activeStatus}
                        isSearchable={false}
                    />
                </FormField>
            </div>
            <Loading loading={isLoading}>
                {menuList.length === 0 ? (
                    <div className="mt-5 mb-5 p-6 max-w-4xl bg-white rounded-xl shadow-lg flex flex-col">
                        <h3 className="text-lg font-bold text-black">
                            {t("Menu is empty")}
                        </h3>
                        <span className="mt-2 text-sm text-gray-800">
                            {t("Welcome to your menu manager. Here you will be able to create and manage all of your menus at every location")}
                        </span>
                    </div>
                ) : (
                    <MenuList
                        uploadedData={menuList}
                        setAlert={setAlert}
                        alert={alert}
                        createMenuHandle={createMenuHandle}
                        onGoToMenuView={onGoToMenuView}
                    />
                )}
            </Loading>

            <div className="max-w-7xl mx-auto mb-6 border-2 px-5 py-11 border-purple-500 flex justify-center items-center">
                <button
                    onClick={allergensModalOpenHandler}
                    type="button"
                    className="mt-1 border-none text-left px-2 focus:ring-gray-200 focus:border-gray-100 bg-gray-100 w-full shadow-sm sm:text-sm rounded-md flex items-center"
                >
                    <img
                        src="/menuicon/stop.svg"
                        alt="stop"
                        width={41}
                        height={41}
                        className="mx-3.5 my-2.5"
                    />
                    <span className="font-semibold">
                        {t("Allergen Database")}
                    </span>
                </button>

                <MenuAllergens
                    visible={openAllergensModal}
                    onClose={allergensModalCloseHandler}
                    onSave={onSaveAllergens}
                />
            </div>
        </div>
    );
};
